<template>
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.5627 9.59817L2.0127 0.906843C1.34614 0.508681 0.499878 0.988918 0.499878 1.76534L0.499877 19.148C0.499877 19.9244 1.34614 20.4046 2.01269 20.0065L16.5627 11.3152C17.2123 10.9271 17.2123 9.98619 16.5627 9.59817Z"
      fill="#FDFDFD"
    />
  </svg>
</template>
